import { SET_KEY_DOWN_EVENT } from '../../types';

const setKeyDownEvent = (status) => (dispatch) => {
  dispatch({ type: SET_KEY_DOWN_EVENT, status });
};

export { setKeyDownEvent };
